import React from "react"
import { Box, Flex } from "@chakra-ui/react"
import CarouselSlide from "./block-image-carousel/CarouselSlide"
import { BlockImageCarouselEntityHydrated } from "@jackfruit/common"
import styled from "@emotion/styled"
import { useCarouselAssets } from "./block-image-carousel/hooks/useCarouselAssets"
import { useCarouselDimension } from "./block-image-carousel/hooks/useCarouselDimension"
import { useCarouselAlignment } from "./block-image-carousel/hooks/useCarouselAlignment"

interface Props {
  config: BlockImageCarouselEntityHydrated
}

const ImageCarouselBlock: React.FC<Props> = ({ config }) => {
  const {
    delay = 0,
    assetsMobile,
    assetsDesktop,
    assetsTablet,
    htmlConfig,
    columnWidth,
    columnWidthXs,
    columnWidthMd,
    alignment,
    alignmentXs,
    alignmentMd,
    style,
  } = config

  const assets = useCarouselAssets(assetsMobile, assetsTablet, assetsDesktop)

  const { carouselWidth, contentWidth } = useCarouselDimension(
    columnWidthXs,
    columnWidthMd,
    columnWidth
  )

  const { carouseAlignment, contentAlignment } = useCarouselAlignment(
    alignmentXs,
    alignmentMd,
    alignment
  )

  if (assets.length === 0) {
    return null
  }

  return (
    <ImageCarouselBlockHero id="carousel-block">
      <Flex
        direction={{
          base: "column",
          md: "row",
        }}
        margin={{ base: "none", md: "2rem" }}
        className="s__carousel-banner-image"
        minH={{ base: "290px", sm: "400px", lg: "500px" }}
      >
        <Box
          aria-label="gallery-carousel-wrapper"
          width={`${carouselWidth}%`}
          padding={{ base: "0.75rem", md: 0 }}
          order={carouseAlignment}
        >
          <CarouselSlide
            delay={delay}
            images={assets}
            indicatorConfig={style}
          />
        </Box>
        <Box
          width={`${contentWidth}%`}
          dangerouslySetInnerHTML={{
            __html: htmlConfig || "",
          }}
          order={contentAlignment}
        />
      </Flex>
    </ImageCarouselBlockHero>
  )
}

export default ImageCarouselBlock

const ImageCarouselBlockHero = styled(Box)(() => ({
  maxWidth: "90rem",
  margin: "0 auto",
}))
